<template>
  <div v-if="form.received != null">
    <section class="user_mail_settings text_center">
      <h2 class="header_underline">お知らせメール受信設定</h2>

      <p class="user_mail_settings_overview text_left">鑑定結果が届いた際や、キャンペーン開催時などにお知らせをする【お知らせメール】の受信設定です。</p>

      <form
        action=""
        method="post"
        class="form"
      >
        <div class="form_group">
          <div class="form_check">
            <input
              id="received_on"
              type="radio"
              name="received"
              value="1"
              v-model="form.received"
            />
            <label for="received_on">お知らせメールを受け取る</label>
          </div>
          <div class="form_check">
            <input
              id="received_off"
              type="radio"
              name="received"
              value="0"
              v-model="form.received"
            />
            <label for="received_off">お知らせメールを受け取らない</label>
          </div>
        </div>
        <div>
          <p v-if="form.errors.length > 0" class="form_error">
            <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
          </p>
          <p>
            <button
              type="submit"
              class="btn arrow"
              :disabled="isSend"
              @click.prevent="checkForm"
            >設定する</button>
          </p>
        </div>
      </form>

      <p class="user_mail_settings_overview notice text_left">
        【お知らせメール】とは、鑑定結果BOXに鑑定結果が届いた際、キャンペーン開催時などにお知らせをする機能です。
        【お知らせメール】を【受け取る】に設定しても【お知らせメール】が届かない場合、会員様の携帯に問題がある可能性がございます。
      </p>
      <p class="user_mail_settings_overview notice text_left">
        各携帯キャリア設定での【ドメイン指定拒否】をされている場合は【解除】をしてください。
      </p>
      <p class="user_mail_settings_overview text_left">解除方法は携帯キャリアにより異なりますので携帯電話ショップなどにお問い合わせください。</p>
      <p><router-link :to="{ name: 'UserProfile' }" class="arrow link_main--text">プロフィール設定に戻る</router-link></p>
    </section>
  </div>
</template>

<script>
import {
  GET_USER_MAIL,
  UPDATE_USER_MAIL
} from '@/store/user/actions'

export default {
  name: 'UserMailSettings',
  data () {
    return {
      form: {
        errors: [],
        received: null
      },
      isSend: false
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.update()
    },
    getMail () {
      this.$store.dispatch(GET_USER_MAIL)
        .then((data) => {
          this.form.received = data.is_sendable
        })
        .catch(() => {
          this.$router.pushIsses({ name: 'UserProfile' })
        })
    },
    update () {
      const params = {
        is_sendable: this.form.received
      }
      this.$store.dispatch(UPDATE_USER_MAIL, params)
        .then((data) => {
          this.$router.pushIsses({ name: 'UserProfile', params: { isNoticeMailChangeSuccess: true } })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          let message = ''
          if (error.errorStatus === 400) {
            message = message + '\n' + error.message
          } else if (error.errorStatus === 422) {
            Object.keys(error.errorData).forEach((key) => {
              error.errorData[key].forEach(entry => {
                this.form.errors.push(entry)
              })
            })
          } else {
            message = error.message
          }

          this.form.errors.push(message)
        })
    }
  },
  created () {
    this.getMail()
  }
}
</script>
